/**
 * Returns the git SHA of the commit the deployment was triggered by,
 * falling back to "<unknown>" if the SHA is not available.
 * @see https://vercel.com/docs/concepts/projects/environment-variables#system-environment-variables
 */
const getReleaseId = () =>
  `${process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA || '<unknown>'}`;

export default getReleaseId;
